import {combineReducers} from "redux";

import posts from "./Posts"
import Auth from "./Auth"
import Userlist from "./Userlist"


export default combineReducers({
    posts,
    Auth,
    Userlist
})